<script setup lang="ts">
import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { PATH_BUSINESS_UNITS_ID_SETTINGS_FIRMWARES } from "~/modules/businessUnit/constants";

const props = defineProps<{
  businessUnitCode: number;
  showFirmwareForm?: boolean;
}>();

const emit = defineEmits(["update:showFirmwareForm"]);

const router = useRouter();

const firmwareListRef = ref();
const { can } = useAcl();

const _showFirmwareForm = computed({
  get() {
    return props.showFirmwareForm;
  },
  set(showFirmwareForm) {
    emit("update:showFirmwareForm", showFirmwareForm);
  },
});

function refreshFirmwareList() {
  firmwareListRef.value?.search();
}
</script>

<template>
  <firmware-list
    ref="firmwareListRef"
    :business-unit-code="businessUnitCode"
    :path-context="
      router.resolve({
        name: PATH_BUSINESS_UNITS_ID_SETTINGS_FIRMWARES,
        params: { id: businessUnitCode },
      }).href
    "
    :can-manage-firmware="can(ACLRoles.CAN_WRITE_FEATURE)"
    use-query-parameters-for-pagination
  />
  <firmware-form
    v-model:side-canvas-shown="_showFirmwareForm"
    :business-unit-code="businessUnitCode"
    @upload="refreshFirmwareList"
  />
</template>
